module.exports = __webpack_public_path__ + "img/FGr_Logistik-Verpflegung.71569e60.svg";